/** City → neighborhood (حي) options for inventory / marketing cascading selects. */

const n = (value) => ({ value, labelAr: value, labelEn: value });

export const NEIGHBORHOODS_BY_CITY = {
  الرياض: [
    'العليا', 'الملز', 'النخيل', 'الشميسي', 'البديعة', 'الروضة', 'الربوة', 'الدرعية',
    'النسيم', 'اليرموك', 'الجنادرية', 'الرمال', 'النرجس', 'الملقا', 'القيروان', 'الياسمين',
    'الصحافة', 'العقيق', 'المرسلات', 'الورود', 'الوادي', 'النهضة', 'الخليج', 'السليمانية',
    'قرطبة', 'طويق', 'عرقة', 'السويدي', 'العريجاء', 'الشفا', 'العزيزية', 'الدار البيضاء',
    'نمار', 'المروج', 'الفيصلية', 'الربيع', 'السلام', 'الياسمين', 'حطين', 'الندى',
    'الغدير', 'الزهراء', 'القدس', 'الخزامى', 'المنار', 'المونسية', 'إشبيليا', 'اليرموك',
  ].filter((v, i, a) => a.indexOf(v) === i).map(n),
  جدة: [
    'الحمراء', 'الروضة', 'الزهراء', 'الشرفية', 'النسيم', 'الصفا', 'النزهة', 'المحمدية',
    'السلامة', 'الكندرة', 'البساتين', 'النعيم', 'الرحاب', 'الروابي', 'المنار', 'الفيصلية',
    'البلد', 'البغدادية', 'المرجان',
  ].map(n),
  الدمام: [
    'الفناتير', 'الفيصلية', 'الروضة', 'الشاطئ', 'الجلوية', 'العدامة', 'العنود', 'المزروعية',
    'الندى', 'طيبة',
  ].map(n),
  مكة: [
    'العزيزية', 'المسفلة', 'الشبيكة', 'التنعيم', 'الكعكية', 'العتيبية', 'الهجرة', 'النور',
  ].map(n),
  المدينة: [
    'العوالي', 'قباء', 'الحرة الشرقية', 'الحرة الغربية', 'شوران', 'العيون', 'الروضة', 'الدفاع',
  ].map(n),
  الخبر: ['العقربية', 'الحزام الذهبي', 'الثقبة', 'اليرموك', 'الراكة', 'الخبر الشمالية'].map(n),
  الظهران: ['الدوحة', 'الجامعة', 'القشلة', 'الحرس'].map(n),
  تبوك: ['المروج', 'الفيصلية', 'الروضة', 'المنطقة المركزية'].map(n),
  بريدة: ['الصفراء', 'الفايزية', 'الريان', 'النقع'].map(n),
  'خميس مشيط': ['الروضة', 'الشامخ', 'النسيم', 'الوسام'].map(n),
  أبها: ['المنسك', 'الاندلس', 'الموظفين', 'الوردتين'].map(n),
  الطائف: ['الشهداء', 'الحوية', 'الفيصلية', 'السداد'].map(n),
  حائل: ['المنتزه', 'الزهراء', 'المطار', 'الورود'].map(n),
  نجران: ['الأثايبة', 'الفهد', 'الفيصلية'].map(n),
  جازان: ['السويس', 'الروضة', 'الشاطئ'].map(n),
  ينبع: ['ينبع البلد', 'ينبع الصناعية', 'البحاري'].map(n),
  الجبيل: ['الجبيل البلد', 'الجبيل الصناعية', 'الفناتير'].map(n),
  الأحساء: ['الهفوف', 'المبرز', 'العمران', 'الجفر'].map(n),
};

export const OTHER_NEIGHBORHOOD = '__other__';

export function getNeighborhoodsForCity(city) {
  if (!city) return [];
  const key = String(city).trim();
  return NEIGHBORHOODS_BY_CITY[key] || NEIGHBORHOODS_BY_CITY[city] || [];
}

export function hasNeighborhoodList(city) {
  return getNeighborhoodsForCity(city).length > 0;
}
